<template>
  <div id="login">
    <img class="login_icon" src="../../assets/logo.png" />
    <div class="login_body">
      <div class="radio_list" v-show="radioList">
        <h3>选择店铺</h3>
        <div
          class="radio_list_s"
          v-for="(item, i) in restaurants"
          :key="item.key"
          :index="item.key"
        >
          <el-radio v-model="radio" :label="i.toString()">{{
            item.name
          }}</el-radio>
        </div>
        <el-button @click="clickRestaurants">确定</el-button>
      </div>
      <el-menu
        v-show="!radioList"
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="1">账户密码登录</el-menu-item>
        <el-menu-item index="2">子账号登录</el-menu-item>
      </el-menu>
    </div>
    <div class="login_body" v-show="!radioList">
      <Signi
        @radioListS="radioListS"
        v-show="activeIndex == 1"
        class="signi_s"
      ></Signi>
      <Signis v-show="activeIndex == 2" class="signi_s"></Signis>
    </div>
  </div>
</template>

<script>
import Signi from '../../components/Signi_in';
import Signis from '../../components/Signi_ins';
import router_list from '../../router_list';

export default {
  name: 'login',
  components: {
    Signi,
    Signis,
  },
  data() {
    return {
      activeIndex: '1',
      radio: '1',
      radioList: false,
      restaurants: [],
    };
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
    },
    radioListS() {
      // this.restaurants = JSON.parse(localStorage.getItem('KC_restaurants'));
      // let roles = JSON.parse(localStorage.getItem('KC_roles'));
      this.getList(router_list.list);
      this.$router.push({ path: '/shop/management-new' });
      // if (this.restaurants.lenght == 0 && roles.find(item => item.id === 1)) {
      // this.getList(router_list.addList);
      // } else {
      //   this.radioList = !this.radioList;
      // }
    },
    clickRestaurants() {
      console.log(this.radio);
      // localStorage.setItem(
      //   'KC_restaurant_id',
      //   JSON.stringify(this.restaurants[this.radio].id)
      // );
      this.getList(router_list.list);
      this.$router.push({ path: '/shop/employee' });
    },
    getList(list) {
      let datalist = list;
      this.$root.headName = [datalist[2], datalist[2].children[0]];
      console.log(this.$root.headName);
    },
  },
};
</script>

<style scoped>
#login {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 100px;
  /* https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg */
  background: url('https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg')
    no-repeat;
}
.login_icon {
  width: 200px;
  height: 200px;
  margin-bottom: 50px;
}
.login_body {
  width: auto;
  display: flex;
  justify-content: center;
}
.el-menu-demo {
  width: 400px;
  display: flex;
  justify-content: space-around;
}
.signi_s {
  width: 400px;
  margin-top: 20px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #1890ff;
  color: #303133;
}
.radio_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.radio_list_s {
  margin: 10px 0;
}
</style>
